function parseFromStringXML(dataString) {
  const parser = new DOMParser();

  return parser.parseFromString(dataString, 'application/xml');
}

function serializeToStringXML(dataDOM) {
  const serializer = new XMLSerializer();

  return serializer.serializeToString(dataDOM);
}

export { parseFromStringXML, serializeToStringXML };
